module.exports = __webpack_public_path__ + "img/spa-salon.07df6f9f.svg";